"use client";

import Image from "next/image";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { DonationCoinIcon } from "@/components/icons/DonationCoinIcon";
import { MotionLinkButton } from "@/components/motion/MotionButton";
import { buttonVariants } from "@/components/ui/button-variants";
import { assets } from "@/content/assets";
import { site } from "@/content/site";

export function FooterBrand() {
  return (
    <div className="footer-brand">
      <Link href="/" className="footer-brand-logo mb-4 inline-flex items-center gap-3">
        <Image
          src={assets.logo}
          alt={site.shortName}
          width={48}
          height={48}
          className="h-12 w-12 shrink-0 rounded-full object-contain"
        />
        <div>
          <p className="text-base font-bold leading-tight text-foreground">
            {site.shortName}
          </p>
          <p className="font-display text-xs font-semibold tracking-widest text-accent">
            FOUNDATION
          </p>
        </div>
      </Link>

      <p className="footer-body mb-5 text-sm leading-relaxed text-muted">
        {site.description}
      </p>

      <MotionLinkButton
        href="/donate"
        wrapperClassName="w-full sm:w-auto"
        className={buttonVariants({
          variant: "accent",
          size: "md",
          className:
            "footer-donate-btn btn-shiny btn-shiny-idle group w-full sm:w-auto",
        })}
      >
        <DonationCoinIcon size={18} className="shrink-0" />
        <span>Support Our Mission</span>
        <ChevronRight
          size={16}
          aria-hidden
          className="transition-transform group-hover:translate-x-0.5"
        />
      </MotionLinkButton>
    </div>
  );
}
